import * as React from 'react'
import styled from 'styled-components'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'

const ID = 'linkedin-third-party-glyph-icon'

export function LinkedInSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <path d="M24.447,24.452 L20.893,24.452 L20.893,18.883 C20.893,17.555 20.866,15.846 19.041,15.846 C17.188,15.846 16.905,17.291 16.905,18.785 L16.905,24.452 L13.351,24.452 L13.351,13 L16.765,13 L16.765,14.561 L16.811,14.561 C17.288,13.661 18.448,12.711 20.181,12.711 C23.782,12.711 24.448,15.081 24.448,18.166 L24.448,24.452 L24.447,24.452 Z M9.337,11.433 C8.193,11.433 7.274,10.507 7.274,9.368 C7.274,8.23 8.194,7.305 9.337,7.305 C10.477,7.305 11.401,8.23 11.401,9.368 C11.401,10.507 10.476,11.433 9.337,11.433 Z M11.119,24.452 L7.555,24.452 L7.555,13 L11.119,13 L11.119,24.452 Z M26.225,4 L5.771,4 C4.792,4 4,4.774 4,5.729 L4,26.271 C4,27.227 4.792,28 5.771,28 L26.222,28 C27.2,28 28,27.227 28,26.271 L28,5.729 C28,4.774 27.2,4 26.222,4 L26.225,4 Z" />
    </symbol>
  )
}

const LinkedInStandaloneContent = standalone(LinkedInSymbol, ID)

export const LinkedIn = styled(function LinkedInStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-linkedin">
      <LinkedInStandaloneContent />
    </Icon>
  )
})``

export const LinkedInLightweight = styled(function LinkedInComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-linkedin">
      {lightweight(ID)}
    </Icon>
  )
})``
